import { MenuCategoryModalView } from '../../components/MenuCategoryModalView';
import { useDetailStore } from '../../hooks';

export const MenuCategoryModal = () => {
  const detailStore = useDetailStore();

  return <MenuCategoryModalView {...detailStore} />;
};
